import * as React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import ProTip from "./ProTip"; // Assuming ProTip is another component
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import MUILink from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./theme";
import Footer from "./components/Footer";
import Impressum from "./pages/Impressum";
import Assets from "./pages/Assets";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: "background.secondary", // Apply background color to the full page
        }}
      >
        <Router>
          {/* AppBar component that is fixed at the top */}
          <AppBar position="fixed">
            <Toolbar>
              <Typography
                color="brightText.primary"
                variant="h6"
                sx={{
                  flexGrow: 1,
                  fontWeight: "bold",
                  display: { xs: "none", sm: "block" }, // Hide on mobile, show on tablets & desktop
                }}
              >
                PEASANT GAMES
              </Typography>
              <Button color="inherit" component={Link} to="/">
                <Typography color="brightText.primary" fontWeight="bold">
                  Home
                </Typography>
              </Button>

              <Button color="inherit" component={Link} to="/assets">
                <Typography color="brightText.primary" fontWeight="bold">
                  Assets
                </Typography>
              </Button>
              <Button
                color="inherit"
                component={Link}
                to="https://store.steampowered.com/app/3580260?utm_source=peasantgamessite"
              >
                <Typography color="brightText.primary" fontWeight="bold">
                  Siegebound
                </Typography>
              </Button>
              <Button color="inherit" component={Link} to="/contact">
                <Typography color="brightText.primary" fontWeight="bold">
                  Contact
                </Typography>
              </Button>
            </Toolbar>
          </AppBar>

          {/* Offset for the fixed AppBar */}
          <Toolbar />

          {/* Main content */}
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/assets" element={<Assets />} />
            </Routes>
          </Box>

          {/* Footer content */}
          <Box
            sx={{ py: 3, textAlign: "center", backgroundColor: "footer.main" }}
          >
            <Footer></Footer>
          </Box>
        </Router>
      </Box>
    </ThemeProvider>
  );
}
